import { getLanguageDisplay } from '@/lib/crm/utils/language';

interface LanguageValueLabelProps {
  value: string;
  fontSize?: 'xs' | 'table' | 'sm' | 'base' | 'lg';
  className?: string;
  truncate?: boolean;
}

const fontSizeClasses = {
  xs: 'text-xs',
  table: 'text-[13px]',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
};

export const LanguageValueLabel: React.FC<LanguageValueLabelProps> = ({
  value,
  fontSize = 'sm',
  className = '',
  truncate,
}) => {
  const sizeClass = fontSizeClasses[fontSize];
  const displayText = getLanguageDisplay(value);
  const truncateClasses = truncate ? 'block truncate' : '';

  return (
    <span
      className={`${sizeClass} ${truncateClasses} ${className}`}
      title={value}
    >
      {displayText}
    </span>
  );
};
